import type { DashboardKpi } from '../../services/api';

export type CashSettlementRaw = {
  expected?: number;
  received?: number;
  uncollected?: number;
} | null | undefined;

export type CashSettlementView = {
  expected: number;
  received: number;
  uncollected: number;
  collectedPct: number;
};

/** Admin-style collection dial inputs from overview extras.cashSettlement. */
export function cashSettlementView(raw: CashSettlementRaw): CashSettlementView {
  const expected = Math.max(0, raw?.expected ?? 0);
  const received = Math.max(0, raw?.received ?? 0);
  const uncollected = Math.max(0, raw?.uncollected ?? Math.max(0, expected - received));
  const collectedPct =
    expected > 0 ? Math.min(100, Math.max(0, (received / expected) * 100)) : received > 0 ? 100 : 0;
  return {
    expected,
    received,
    uncollected,
    collectedPct: Math.round(collectedPct * 10) / 10,
  };
}

export type ChannelMixItem = { name: string; value: number };

/** Drop zero/negative channel bars so empty charts stay empty. */
export function channelMixFromKpis(
  entries: Array<{ name: string; kpi?: DashboardKpi | null; value?: number }>,
): ChannelMixItem[] {
  return entries
    .map((e) => ({
      name: e.name,
      value: e.value ?? e.kpi?.value ?? 0,
    }))
    .filter((d) => d.value > 0);
}
